import React from 'react';
import { connect } from 'react-redux';
import styled, { css } from "styled-components";

const ErrorTooltipWrapper = styled.div` 
  ${(props) => {
    const { inline, topOffset=0, styles: { errorText={}, tooltip={} }  } = props,
          ebc = '#CC0000',
          ec = '#FFFFFF';

  return css`
      && {
        ${inline &&
          'display: inline-block; margin-left: 10px;'
        }
        
        .help-icon {
          position: ${inline ? 'unset' : 'absolute'};
          z-index: 1;
          right: 13px;
          top: ${`${(10 + topOffset)}px`};
          i {
            color: ${ebc}
          }
        }
      
        .help-info {
          margin: 5px;
          padding: 10px;
          border-radius: 6px;
          background: ${ebc};
          color: ${ec};
          position: absolute;
          top: ${`${(-40 + topOffset)}px`};
          max-width: 500px;
          height: max-content;
          right: 0;
          z-index: 100;
          box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
        }
        
        .help-info:before {
          content: ' ';
          height: 0;
          position: absolute;
          width: 0;
          right: 4px;
          top: 35px;
          border: 10px solid transparent;
          border-top-color: ${ebc};
        }
      }`
  }}
`;

class ErrorTooltip extends React.Component {
  render() {
    const { inline, styles, topOffset } = this.props;

    return (
      <ErrorTooltipWrapper className='error-tooltip' topOffset={topOffset} inline={inline} styles={styles}>
        <div className='help-icon'>
          <a>
            <i className="fa fa-exclamation-circle" />
          </a>
        </div>

        <div className="card help-info">
          <div className="card-body">
            {this.props.message}
          </div>
        </div>
      </ErrorTooltipWrapper>
    )
  }
}

export default connect(
  ({settings: {style = {}}}) => ({
    styles: style,
  })
)(ErrorTooltip);
